import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ManageSchoolLayout from './manage-school/ManageSchoolLayout';
import BasicInfo from './manage-school/basic/index';
import Admissions from './manage-school/admissions/index';
import ExtraCurricular from './manage-school/extra/index';
import Infrastructure from './manage-school/infrastructure/index';
import Jobs from './manage-school/jobs/index';
import Media from './manage-school/media/index';
import Blogs from './manage-school/blogs/index';
import Team from './manage-school/team/index';
import NotificationCenter from './manage-school/notifications/index';
import Reviews from './manage-school/reviews/index';
import QA from './manage-school/qa/index';
import CounsellorsAdmin from './manage-school/counsellors/index';
import Stories from './manage-school/stories/index';
import InstaStories from './manage-school/instastories/index';
import RelatedSchools from './manage-school/related_schools/index';
import AppearsInSchools from './manage-school/appears_in_schools/index';
import TargetLocations from './manage-school/target_locations/index';
import BusRoutes from './manage-school/bus_routes/index';
import FeeStructure from './manage-school/fee/index';
import FAQs from './manage-school/faqs/index';

const ManageSchool: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<ManageSchoolLayout />}>
                <Route index element={<Navigate to="basic" replace />} />
                <Route path="basic" element={<BasicInfo />} />
                <Route path="admissions" element={<Admissions />} />
                <Route path="extra" element={<ExtraCurricular />} />
                <Route path="infrastructure" element={<Infrastructure />} />
                <Route path="jobs/*" element={<Jobs />} />
                <Route path="media/*" element={<Media />} />
                <Route path="blogs/*" element={<Blogs />} />
                <Route path="team" element={<Team />} />
                <Route path="notifications" element={<NotificationCenter />} />
                <Route path="reviews" element={<Reviews />} />
                <Route path="qa" element={<QA />} />
                <Route path="counsellors" element={<CounsellorsAdmin />} />
                <Route path="stories" element={<Stories />} />
                <Route path="instastories" element={<InstaStories />} />
                <Route path="related_schools" element={<RelatedSchools />} />
                <Route path="appears_in_schools" element={<AppearsInSchools />} />
                <Route path="target_locations" element={<TargetLocations />} />
                <Route path="bus_routes" element={<BusRoutes />} />
                <Route path="fee" element={<FeeStructure />} />
                <Route path="faqs" element={<FAQs />} />
            </Route>
        </Routes>
    );
};

export default ManageSchool;
